import {
  GET_ALL_ADMINS,
  PLAN_NAME,
  SUBSCRIPTION_DATA,
  USER_DETAILS,
  ENGAGEMENT_DATA,
  ADD_GAME_DATA,
  ADD_HOME_SCHEDULE_DATA,
  ADD_CHANNEL_DATA
} from '../types';

const INITIAL_STATE = {
  planName: null,
  admins: [],
  subscriptionDetails: {},
  enagagementData: {},
  userDetails: {},
  gameData: {},
  scheduleData: {
    upcoming: [],
    teamName: null,
    isAdmin: false
  },
  channelData: {
    allChannels: []
  }
};

const homeReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case PLAN_NAME:
      return { ...state, planName: action.payload };
    case SUBSCRIPTION_DATA:
      return { ...state, subscriptionDetails: action.payload };
    case ENGAGEMENT_DATA:
      return { ...state, enagagementData: action.payload };
    case USER_DETAILS:
      return { ...state, userDetails: action.payload };
    case GET_ALL_ADMINS:
      return { ...state, admins: action.payload };
    case ADD_GAME_DATA:  
      return { ...state, gameData: action.payload };
    case ADD_HOME_SCHEDULE_DATA:
      // If backend doesn't provide isAdmin, derive it from userDetails
      const scheduleData = {
        ...action.payload,
        isAdmin: action.payload.isAdmin !== undefined 
          ? action.payload.isAdmin 
          : state.userDetails?.isAdmin || false
      };
      return { ...state, scheduleData };
    case ADD_CHANNEL_DATA:
      return { ...state, channelData: action.payload };
    default:
      return state;
  }
};

export default homeReducer;
